import { Box, Stack } from '@mui/material'
import { COLORS } from 'styles/colors'
import { OutlinedButton } from 'ui/buttons/OutlinedButton'
import ExpandableCard from 'ui/expandable-card/ExpandableCard'
import { TypographyHeader14 } from 'ui/typography/TypographyHeader14'
import { TypographyPrimary } from 'ui/typography/TypographyPrimary'
import { TypographyPrimary16Bold } from 'ui/typography/TypographyPrimary16Bold'
import { questionsData } from '../options/faqOptions'

export const Questions = () => {
	return (
		<Box
			sx={{
				height: '100%',
				display: 'flex',
				flexDirection: 'column',
				gap: '40px',
				maxWidth: '100%',
			}}
		>
			<Box sx={{ display: 'grid', gridTemplateColumns: '300px 1fr' }}>
				<TypographyPrimary16Bold>
					Часто задаваемые вопросы
				</TypographyPrimary16Bold>
				<Stack direction={'column'} gap={'24px'}>
					{questionsData.map((el, index) => (
						<ExpandableCard
							key={`question-${index}`}
							isDefaultOpen={false}
							titleContent={
								<TypographyHeader14>{el.question}</TypographyHeader14>
							}
						>
							<TypographyPrimary sx={{ mt: '16px' }}>
								{el.answer}
							</TypographyPrimary>
						</ExpandableCard>
					))}
				</Stack>
			</Box>
			<Box sx={{ display: 'grid', gridTemplateColumns: '300px 1fr' }}>
				<TypographyPrimary16Bold>
					Не нашли ответ на
					<br /> Ваш вопрос?
				</TypographyPrimary16Bold>
				<OutlinedButton
					sx={{
						margin: '0px',
						borderColor: COLORS.main,
						color: COLORS.main,
						'&:hover': {
							opacity: 0.7,
							backgroundColor: 'transparent',
							color: COLORS.main,
							boxShadow: 'none',
						},
					}}
					onClick={() =>
						window.open(
							'https://smartfarm.vision/help',
							'_blank',
							'noopener,noreferrer',
						)
					}
				>
					Свяжитесь с нами
				</OutlinedButton>
			</Box>
		</Box>
	)
}
